import { CORE_LOCATION_GENERAL_FILTER_MAP } from './core-location-filter-map.config';
import { CORE_PRODUCT_GENERAL_FILTER_MAP } from './core-product-filter-map.config';

export const CORE_GENERAL_FILTER_MAP = {
  ...CORE_PRODUCT_GENERAL_FILTER_MAP,
  ...CORE_LOCATION_GENERAL_FILTER_MAP,
};
